(function() {
    'use strict';
    
    let clickref = null;
    let partnertype = null;
    let dataStored = false;

    // Function to store affiliate data
    function storeAffiliateData() {
        if (dataStored || !clickref) return;
        
        try {
            // Determine cookie name based on partner type
            const isCashbackPartner = partnertype && (
                partnertype.toLowerCase().includes('cashback') || 
                partnertype.toLowerCase().includes('loyalty')
            );
            const cookieName = isCashbackPartner ? "clickref" : "non-cashback";
            
            let cookieString = cookieName + "=" + clickref + "; path=/; max-age=" + (60*60*24*30) + "; SameSite=Lax";
            document.cookie = cookieString;
            localStorage.setItem(cookieName, clickref);
            
            // Store partnertype if it exists
            if (partnertype) {
                let partnertypeCookieString = "partnertype=" + encodeURIComponent(partnertype) + "; path=/; max-age=" + (60*60*24*30) + "; SameSite=Lax";
                document.cookie = partnertypeCookieString;
                localStorage.setItem("partnertype", partnertype);
            }
            
            dataStored = true;
        } catch(e) {
            console.error("Affiliate cookie error:", e);
        }
    }

    // Function to check if user has given cookie consent
    function hasConsent() {
        if (!window.Shopify || !window.Shopify.customerPrivacy) {
            return false;
        }
        
        if (typeof window.Shopify.customerPrivacy.getTrackingConsent === 'function') {
            const consent = window.Shopify.customerPrivacy.getTrackingConsent();
            return consent && (consent.analytics === true || consent.marketing === true);
        }
        
        return false;
    }

    // Function to check consent and store if allowed
    function checkConsentAndStore() {
        if (hasConsent()) {
            storeAffiliateData();
            return true;
        }
        return false;
    }

    // Function to wait for consent for non-cashback partners
    function waitForConsent() {
        // Check immediately
        if (checkConsentAndStore()) {
            return;
        }

        // Listen for customerPrivacy API ready event
        document.addEventListener('customerPrivacyAPIReady', function() {
            checkConsentAndStore();
        });

        // Poll for consent changes (as a fallback)
        let consentCheckInterval = setInterval(function() {
            if (checkConsentAndStore()) {
                clearInterval(consentCheckInterval);
            }
        }, 500);

        // Stop polling after 30 seconds
        setTimeout(function() {
            clearInterval(consentCheckInterval);
        }, 30000);
    }

    // Main function to initialize affiliate tracking
    function initAffiliateTracking() {
        try {
            let urlParams = new URLSearchParams(window.location.search);
            partnertype = urlParams.get('partnertype');
            clickref = urlParams.get('clickref');

            if (!clickref) return;

            // Check if this is a cashback partner
            const isCashbackPartner = partnertype && (
                partnertype.toLowerCase().includes('cashback') || 
                partnertype.toLowerCase().includes('loyalty')
            );

            // For cashback partners, store immediately regardless of cookie consent
            if (isCashbackPartner) {
                storeAffiliateData();
                
                // Also set tracking consent for cashback partners
                if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
                    window.Shopify.customerPrivacy.setTrackingConsent({
                      analytics: true,
                      marketing: true,
                      preferences: true,
                      sale_of_data: true
                    });
                }
            } else {
                // For non-cashback partners, check cookie consent first
                // Wait for customerPrivacy API to be ready if needed
                if (window.Shopify && window.Shopify.customerPrivacy) {
                    // Check if consent already exists
                    if (checkConsentAndStore()) {
                        return;
                    }
                    // Wait for consent
                    waitForConsent();
                } else {
                    // If customerPrivacy API is not available, wait for it to load
                    document.addEventListener('customerPrivacyAPIReady', function() {
                        if (checkConsentAndStore()) {
                            return;
                        }
                        waitForConsent();
                    });
                    
                    // Also poll for API availability as fallback
                    let apiCheckInterval = setInterval(function() {
                        if (window.Shopify && window.Shopify.customerPrivacy) {
                            clearInterval(apiCheckInterval);
                            if (checkConsentAndStore()) {
                                return;
                            }
                            waitForConsent();
                        }
                    }, 100);
                    
                    // Stop checking after 10 seconds
                    setTimeout(function() {
                        clearInterval(apiCheckInterval);
                    }, 10000);
                }
            }
        } catch(e) {
            console.error("Affiliate tracking error:", e);
        }
    }

    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAffiliateTracking);
    } else {
        initAffiliateTracking();
    }
})();
